<template>
  <div class="c-domain-check">
    <form class="c-form" v-on:submit.prevent="checkDomain">
      <div class="c-form__title">
        {{ trans('domain_check') }}
        <div class="sk-fading-circle" v-if="loading">
          <div class="sk-circle1 sk-circle"></div>
          <div class="sk-circle2 sk-circle"></div>
          <div class="sk-circle3 sk-circle"></div>
          <div class="sk-circle4 sk-circle"></div>
          <div class="sk-circle5 sk-circle"></div>
          <div class="sk-circle6 sk-circle"></div>
          <div class="sk-circle7 sk-circle"></div>
          <div class="sk-circle8 sk-circle"></div>
          <div class="sk-circle9 sk-circle"></div>
          <div class="sk-circle10 sk-circle"></div>
          <div class="sk-circle11 sk-circle"></div>
          <div class="sk-circle12 sk-circle"></div>
        </div>
      </div>
      <div class="c-form__body">
        <span>www.</span>
        <input type="text" name="domain" class="c-form__input" v-model="domain">
        <div class="c-custom-select">
          <select class="c-custom-select__select" v-model="tld">
            <option v-for="item in tlds" v-bind:key="item.value" v-bind:value="item.value">{{ item.name }}</option>
          </select>
        </div>
        <button type="button" class="c-form__button" v-on:click="checkDomain">{{ trans('check') }}</button>
      </div>
    </form>
    <div class="c-result" v-if="showInfo">
      <domain-info v-bind:data="domainInfo"></domain-info>
      <domain-info v-for="item in alternativeDomains" v-bind:key="item.domain" v-bind:data="item"></domain-info>
    </div>
  </div>
</template>

<script>
import DomainInfo from './components/DomainInfo.vue';
import trans from './mixins/trans';
import axios from 'axios';
import swal from 'sweetalert';

export default {
    name: 'app',
    mixins: [trans],
    components: {
        'domain-info': DomainInfo
    },
    data() {
        return {
            loading: false,
            domain: '',
            tld: 'ge',
            tlds: window.tlds,
            domainInfo: {},
            alternativeDomains: []
        };
    },
    mounted() {
        if (window.domain !== undefined && window.tld !== undefined) {
            this.domain = window.domain;
            this.tld = window.tld;
            this.$nextTick(this.checkDomain);
        }
    },
    methods: {
        checkDomain() {
            if (this.domain.length < 2) {
                swal(
                    this.trans('attention'),
                    this.trans('enter_domain'),
                    'warning'
                );
                return false;
            }
            if (!this.validateDomain()) {
                swal(
                    this.trans('attention'),
                    this.trans('incorrect_domain_format'),
                    'warning'
                );
                return false;
            }
            this.domainInfo = {};
            this.alternativeDomains = [];
            this.checkAlternativeDomains();
            this.loading = true;
            axios
                .get(
                    `https://ns.ge/ajax.php?module=check_domain&domain=${
                        this.domain
                    }&tld=${this.tld}&single=true`
                )
                .then(response => {
                    this.domainInfo = response.data;
                })
                .catch(error => {
                    swal(
                        this.trans('attention'),
                        this.trans('connection_error'),
                        'error'
                    );
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        checkAlternativeDomains() {
            this.tlds.forEach(tld => {
                if (
                    tld.value != this.tld &&
                    !(tld.value == 'გე' && this.isLatin(this.domain))
                ) {
                    let domain =
                        !this.isLatin(this.domain) && tld.value !== 'გე'
                            ? this.toLatin(this.domain)
                            : this.domain;
                    axios
                        .get(
                            `https://ns.ge/ajax.php?module=check_domain&domain=${domain}&tld=${
                                tld.value
                            }&single=true`
                        )
                        .then(response => {
                            this.alternativeDomains.push(response.data);
                        })
                        .catch(error => {
                            console.error(error);
                        });
                }
            });
        },
        validateDomain() {
            return !this.domain.match(/[.,/|\\]/);
        },
        isLatin(text) {
            var latinRange = /[\u0061-\u007A]/;
            var latinUpperRange = /[\u0041-\u005A]/;
            return latinRange.test(text) || latinUpperRange.test(text);
        },
        toLatin: function(val) {
            let geo = {
                ა: 'a',
                ბ: 'b',
                გ: 'g',
                დ: 'd',
                ე: 'e',
                ვ: 'v',
                ზ: 'z',
                თ: 'T',
                ი: 'i',
                კ: 'k',
                ლ: 'l',
                მ: 'm',
                ნ: 'n',
                ო: 'o',
                პ: 'p',
                ჟ: 'J',
                რ: 'r',
                ს: 's',
                ტ: 't',
                უ: 'u',
                ფ: 'f',
                ქ: 'q',
                ღ: 'gh',
                ყ: 'k',
                შ: 'sh',
                ჩ: 'C',
                ც: 'c',
                ძ: 'dz',
                წ: 'ts',
                ჭ: 'ch',
                ხ: 'kh',
                ჯ: 'j',
                ჰ: 'h'
            };
            return val
                .split('')
                .map(function(char) {
                    return geo.hasOwnProperty(char) ? geo[char] : char;
                })
                .join('');
        }
    },
    computed: {
        showInfo() {
            return Object.keys(this.domainInfo).length > 0;
        }
    },
    watch: {
        domain(val) {
            this.domain = val.replace(/\s/, '');
            if (val.length > 0 && !this.isLatin(val)) {
                this.tld = 'გე';
            } else if (
                val.length > 0 &&
                this.isLatin(val) &&
                this.tld == 'გე'
            ) {
                this.tld = 'ge';
            }
        }
    }
};
</script>

<style lang="scss">
.c-domain-check {
    display: block;
    width: 700px;
    margin: 0 auto;
    margin-top: 15px;
}
.c-form {
    display: block;
    width: 100%;
    margin: 0 auto;
    border: 1px Dotted Silver;
    &__title {
        position: relative;
        background-color: #f6f6f6;
        text-align: center;
        font-size: 11px;
        height: 20px;
        line-height: 20px;
    }
    &__body {
        padding: 5px;
        padding-top: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &__input {
        margin-left: 5px;
        border: 1px solid silver;
    }
    &__button {
        width: 75px;
        border: 1px solid silver;
    }
}
.c-custom-select {
    margin: 0 7px;
}

.sk-fading-circle {
    position: absolute;
    top: 0;
    right: 5px;
    width: 20px;
    height: 20px;
}
.sk-fading-circle .sk-circle {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
.sk-fading-circle .sk-circle:before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: #333;
    border-radius: 100%;
    -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
    animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
}
.sk-fading-circle .sk-circle2 {
    -webkit-transform: rotate(30deg);
    -ms-transform: rotate(30deg);
    transform: rotate(30deg);
}
.sk-fading-circle .sk-circle3 {
    -webkit-transform: rotate(60deg);
    -ms-transform: rotate(60deg);
    transform: rotate(60deg);
}
.sk-fading-circle .sk-circle4 {
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
}
.sk-fading-circle .sk-circle5 {
    -webkit-transform: rotate(120deg);
    -ms-transform: rotate(120deg);
    transform: rotate(120deg);
}
.sk-fading-circle .sk-circle6 {
    -webkit-transform: rotate(150deg);
    -ms-transform: rotate(150deg);
    transform: rotate(150deg);
}
.sk-fading-circle .sk-circle7 {
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}
.sk-fading-circle .sk-circle8 {
    -webkit-transform: rotate(210deg);
    -ms-transform: rotate(210deg);
    transform: rotate(210deg);
}
.sk-fading-circle .sk-circle9 {
    -webkit-transform: rotate(240deg);
    -ms-transform: rotate(240deg);
    transform: rotate(240deg);
}
.sk-fading-circle .sk-circle10 {
    -webkit-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
}
.sk-fading-circle .sk-circle11 {
    -webkit-transform: rotate(300deg);
    -ms-transform: rotate(300deg);
    transform: rotate(300deg);
}
.sk-fading-circle .sk-circle12 {
    -webkit-transform: rotate(330deg);
    -ms-transform: rotate(330deg);
    transform: rotate(330deg);
}
.sk-fading-circle .sk-circle2:before {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
}
.sk-fading-circle .sk-circle3:before {
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
}
.sk-fading-circle .sk-circle4:before {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
}
.sk-fading-circle .sk-circle5:before {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
}
.sk-fading-circle .sk-circle6:before {
    -webkit-animation-delay: -0.7s;
    animation-delay: -0.7s;
}
.sk-fading-circle .sk-circle7:before {
    -webkit-animation-delay: -0.6s;
    animation-delay: -0.6s;
}
.sk-fading-circle .sk-circle8:before {
    -webkit-animation-delay: -0.5s;
    animation-delay: -0.5s;
}
.sk-fading-circle .sk-circle9:before {
    -webkit-animation-delay: -0.4s;
    animation-delay: -0.4s;
}
.sk-fading-circle .sk-circle10:before {
    -webkit-animation-delay: -0.3s;
    animation-delay: -0.3s;
}
.sk-fading-circle .sk-circle11:before {
    -webkit-animation-delay: -0.2s;
    animation-delay: -0.2s;
}
.sk-fading-circle .sk-circle12:before {
    -webkit-animation-delay: -0.1s;
    animation-delay: -0.1s;
}
@-webkit-keyframes sk-circleFadeDelay {
    0%,
    39%,
    100% {
        opacity: 0;
    }
    40% {
        opacity: 1;
    }
}
@keyframes sk-circleFadeDelay {
    0%,
    39%,
    100% {
        opacity: 0;
    }
    40% {
        opacity: 1;
    }
}
#app {
    font-family: 'Verdana', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue